import { CardActions, Grid, Menu, MenuItem } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey } from "assets/jss/common-styles";
import ButtonEllipsis from "components/Buttons/ButtonEllipsis";
import IconCompleted from "components/Icons/IconCompleted";
import IconEnrollments from "components/Icons/IconEnrollments";
import MuiFakeButton from "components/MuiExtras/Button/MuiFakeButton";
import MuiRegularButton from 'components/MuiExtras/Button/MuiRegularButton';
import MuiConfirmation from "components/MuiExtras/MuiConfirmation";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import { FeedType } from "models/ApiEnums";
import { FeedItemDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { CourseActions } from "views/Publication/Components/CourseModels";
import CourseEnrollReviewDrawer from "views/Publication/Dialogs/CourseEnrollReviewDrawer";
import ActionsSocial from "views/Timeline/Components/CardComp/ActionsSocial";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    dialog: any;
    menuAnchorEl: any;
}

interface IProps {
    item: FeedItemDto;
    feedType: FeedType;
    onUpdateCard: (item: DeepPartial<FeedItemDto>) => void;
    onCustomAction: (customAction: any) => void;
}

type Props = IProps & StyledComponentProps<FeedClassKey> & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class ActionsCourse extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            dialog: null,
            menuAnchorEl: null,
        };
    }

    ///
    private handleEnrollReview = () => {
        this.setState({
            dialog: <CourseEnrollReviewDrawer
                allowManageEnroll={false}
                courseId={this.props.item.publicationId}
                onClose={() => this.setState({ dialog: null })}
            />
        });
    };

    ///
    private handleEnrollCancel = () => {

        this.setState({
            dialog: <MuiConfirmation
                title={this.props.t("Common.Feed.Course.ConfirmationCancelEnrollmentTitle")}
                message={this.props.t("Common.Feed.Course.ConfirmationCancelEnrollmentMessage")}
                onClose={(result) => {
                    if (result) {
                        this.setState({ dialog: null, menuAnchorEl: null }, () => this.props.onCustomAction({ feed: { actionName: "cancelEnroll" } }));
                    }
                    else {
                        this.setState({ dialog: null, menuAnchorEl: null });
                    }
                }}
            />
        });
    };

    ///
    public render() {

        const {
            classes,
            item,
            feedType,
            onUpdateCard,
            onCustomAction
        } = this.props;

        const {
            menuAnchorEl
        } = this.state;

        return (
            <>
                {this.state.dialog}

                <CardActions className={classes.cardActions} >

                    <Grid container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Grid item>
                            {
                                feedType == FeedType.CourseEnrolled
                                    ? (
                                        <MuiFakeButton simple color={"transparent"}>
                                            <IconCompleted progress={item.interaction.courseEnroll.progress} />
                                            <span>&nbsp;{this.props.t("Common.Feed.Course.ProgressMessage", { progress: item.interaction.courseEnroll.progress })}</span>
                                        </MuiFakeButton>
                                    )
                                    : (
                                        <MuiRegularButton
                                            simple
                                            title={this.props.t("Common.Feed.Course.ButtonEnrollTitle")}
                                            color="transparent"
                                            onClick={this.handleEnrollReview}
                                        >
                                            <IconEnrollments />
                                            <span>&nbsp;{item.statistics.enrollments}</span>
                                        </MuiRegularButton>
                                    )
                            }
                        </Grid>

                        <Grid item>
                            <ActionsSocial
                                data={item}
                                fullView={false}
                                showCommentsButton={true}
                                onUpdateCard={onUpdateCard}
                            />
                        </Grid>

                        <Grid item>
                            {
                                feedType == FeedType.CourseAutoEnroll &&
                                item.interaction.courseEnroll.enrolledOn == null &&
                                <MuiRegularButton
                                    color="success"
                                    onClick={() => onCustomAction({ feed: { actionName: "enroll" } } as CourseActions)}
                                >
                                    <span>{this.props.t("Common.Feed.Course.ButtonEnrollText")}</span>
                                </MuiRegularButton>
                            }

                            {
                                feedType == FeedType.CourseEnrolled &&
                                <>
                                    {
                                        !item.interaction.courseEnroll.expired &&
                                        <MuiRegularButton
                                            color={item.interaction.courseEnroll.startedOn == null ? "info" : "warning"}
                                            onClick={() => onCustomAction({ feed: { actionName: "view" } } as CourseActions)}
                                        >
                                            {
                                                item.interaction.courseEnroll.startedOn == null
                                                    ? this.props.t("Common.Feed.Course.ButtonStartText")
                                                    : this.props.t("Common.Feed.Course.ButtonContinueText")
                                            }
                                        </MuiRegularButton>
                                    }

                                    {
                                        item.permissions.canDelete === true &&
                                        <>
                                            <ButtonEllipsis
                                                onClick={(e) => { this.setState({ menuAnchorEl: e.currentTarget }); }}
                                            />
                                            <Menu
                                                anchorEl={menuAnchorEl}
                                                open={menuAnchorEl != null}
                                                onClose={() => this.setState({ menuAnchorEl: null })}
                                            >
                                                <MenuItem onClick={this.handleEnrollCancel}>
                                                    <MuiColor variant="error">{this.props.t("Common.Feed.Course.CancelEnrollmentText")}</MuiColor>
                                                </MenuItem>
                                            </Menu>
                                        </>
                                    }
                                </>

                            }

                            {
                                feedType == FeedType.CourseCompleted &&
                                <MuiRegularButton
                                    color="info"
                                    onClick={() => onCustomAction({ feed: { actionName: "view" } } as CourseActions)}
                                >
                                    <span>{this.props.t("Common.Feed.Course.ButtonReviewText")}</span>
                                </MuiRegularButton>
                            }

                        </Grid>
                    </Grid>
                </CardActions>
            </>
        );
    }
}

export default withTranslation()(ActionsCourse);